import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';

import { Status, statusValues } from '../../../../liabilities/models/expenses';
import { FormControlType, Row } from '../../../models/table';
import { TableAbstractComponent } from '../table.abstract.component';
import { MatRipple } from '@angular/material/core';
import { Liability } from '../../../../liabilities/models/liability.model';
import { MatTableModule } from '@angular/material/table';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../../icon/icon.component';
import { MatCheckbox } from '@angular/material/checkbox';
import { SafeHtmlPipe } from '../../../utils/pipes/safe-html.pipe';
import { LiabilityExpandableMenuComponent } from '../liability-expandable-menu/liability-expandable-menu.component';
import { ExpandedRowComponent } from '../expanded-row/expanded-row.component';
import { MatIconButton } from '@angular/material/button';
import { DefaultLayoutDirective } from 'ng-flex-layout';
import { MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { DeviceService } from '../../../services/device.service';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTooltip } from '@angular/material/tooltip';
import { EnterTogglesCheckboxDirective } from '../../../directives/enterTogglesCheckbox.directive';


@Component({
  selector: 'app-desktop-table',
  templateUrl: './desktop.table.component.html',
  styleUrls: ['./desktop.table.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
  imports: [MatTableModule,
    CommonModule, IconComponent, MatCheckbox, SafeHtmlPipe, LiabilityExpandableMenuComponent,
    ExpandedRowComponent, MatIconButton, DefaultLayoutDirective, MatInput, FormsModule, MatPaginator, MatTooltip, EnterTogglesCheckboxDirective],
  standalone: true,

})
export class DesktopTableComponent<T extends Row> extends TableAbstractComponent<T> implements OnInit, AfterViewInit {
  // todo
  //dodanie dynamicznego tworzneia komponetu ktory pojawia sie przy rozwijaniu
  protected readonly FormControlType = FormControlType;

  @ViewChild(MatRipple) public ripple: MatRipple;
  private _liability: Liability;
  public get liability(): Liability {
    return this._liability;
  }

  @Input() public startedPaymentId: string;

  _totalCount: number;
  @Input() set totalCount(count: number) {
    this._totalCount = count;
  }

  get totalCount() {
    return this._totalCount;
  }

  @Output() public liabilityMarkedAsPaidEvent = new EventEmitter<void>();


  @Input() public rowStyle: (row: T) => any;

  protected readonly status = Status;
  protected readonly values = statusValues;
  public columnsDesktopNames = [];


  constructor(public deviceService: DeviceService) {
    super();
  }

  ngOnInit(): void {
    this.columns = this.columns.filter(it => !it.hide);
    this.columnsDesktopNames = this.columns.map(it => it.name);
    this.ripple = <MatRipple>{ disabled: false };

    this.columns.push({
      hide: true,
      hideOnMobile: true,
      name: 'index',
      label: '',
    });

    if (this.editable) {
      this.columnsDesktopNames = [...this.columnsDesktopNames, 'editableMenu'];
    }

    if (this.isExpandable) {
      this.columnsDesktopNames = [...this.columnsDesktopNames, 'expanded'];
    }

    if (this.isSelectable) {
      this.columnsDesktopNames = ['checkboxSelect', ...this.columnsDesktopNames];
    }
    if (this.isFloatingMenu) {
      this.columnsDesktopNames = [...this.columnsDesktopNames, 'expandableMenu'];
    }

  }

  pageSize: number;
  pageIndex: number;
  _pageEvent: PageEvent;

  handlePageEvent(e: PageEvent) {

    this._pageEvent = e;
    this._totalCount = e.length;
    this.pageSize = e.pageSize;
    this.pageIndex = e.pageIndex;
    this.pageEvent.emit(e);
  }

  ngAfterViewInit() {
    if(this.pageable){
      this.paginator.length = this._totalCount;
      this.dataSource.paginator = this.paginator;
    }
  }

  public blockEvents(event): void {
    event.stopPropagation();
  }

  getValue(element: any, columnName: string): any {
    return element[columnName];
  }

  expandRow(element: T) {
    this.expandedElement = element;
  }

  hideRow() {
    this.expandedElement = null;
  }

  checkboxValue(element: any, columnName: string): any {
    return element[columnName];
  }

  checkboxChecked(element: any, columnName: string): any {
    return element[columnName];
  }

  checkboxIndeterminate(element: any, columnName: string): any {
    return element[columnName] === false;

  }

  toggleCheckbox(row: any, name: any) {
    let currentValue = this.getValue(row, name);

    if (currentValue === null) {
      row[name] = true;
    } else if (currentValue === true) {
      row[name] = false;
    } else {
      row[name] = null;
    }
  }

  isApple() {
    return this.deviceService.isIOS();
  }

}
